<template>
  <div class="history-tab">
    <ulu-order-history-order-table />
    <ulu-order-history-devices-table />
    <ulu-order-history-requester />
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    "ulu-order-history-order-table": () =>
      import(
        "@/components/orders/order/order_history_tab/OrderHistoryTabOrders"
      ),
    "ulu-order-history-devices-table": () =>
      import(
        "@/components/orders/order/order_history_tab/OrderHistoryTabDevices"
      ),
    "ulu-order-history-requester": () =>
      import(
        "@/components/orders/order/order_history_tab/OrderHistoryTabRequester"
      )
  }
};
</script>

<style scoped>
.history-tab {
  display: flex;
  flex-direction: column;
  gap: 32px;
}
</style>
